import { useRef, useEffect, useState } from 'react';

const SecurePDFCanvas = ({ pdfDocument, pageNumber, scale = 1.0, userId, userName }) => {
  const canvasRef = useRef(null);
  const [renderError, setRenderError] = useState(null);

  useEffect(() => {
    if (!pdfDocument || !canvasRef.current) return;
    let cancelled = false;

    (async () => {
      try {
        await pdfDocument.renderPage(pageNumber - 1, scale, canvasRef.current);
        if (cancelled) return;

        // واترمارک امنیتی
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d', { alpha: false });

        ctx.save();
        ctx.globalCompositeOperation = 'source-atop';
        ctx.fillStyle = 'rgba(255, 255, 255, 0.06)';

        const fontSize = Math.max(24, Math.round(canvas.width / 70));
        ctx.font = `bold ${fontSize}px Vazirmatn, Arial`;
        ctx.textAlign = 'center';

        const wm = `${userName || 'کاربر'} - ${(userId || '').slice(-4)}`;
        const today = new Date().toLocaleDateString('fa-IR');

        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate(-Math.PI / 6);

        const stepY = fontSize * 6;
        const stepX = fontSize * 10;

        for (let y = -canvas.height; y < canvas.height; y += stepY) {
          for (let x = -canvas.width; x < canvas.width; x += stepX) {
            ctx.fillText(wm, x, y);
            ctx.fillText(today, x, y + fontSize * 1.8);
          }
        }

        ctx.restore();
        setRenderError(null);
      } catch (err) {
        if (!cancelled) {
          console.error('❌ خطا در رندر صفحه:', err);
          setRenderError(err.message);
        }
      }
    })();

    return () => { cancelled = true; };
  }, [pdfDocument, pageNumber, scale, userId, userName]);

  // غیرفعال‌سازی toDataURL / toBlob
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const o1 = canvas.toDataURL, o2 = canvas.toBlob;
    canvas.toDataURL = () => 'data:image/png;base64,';
    canvas.toBlob = (cb) => cb?.(null);
    return () => { canvas.toDataURL = o1; canvas.toBlob = o2; };
  }, []);

  if (renderError) {
    return (
      <div className="secure-pdf-container">
        <div className="page-placeholder">
          <span>⚠️ {renderError}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="secure-pdf-container" onContextMenu={(e) => e.preventDefault()}>
      <canvas
        ref={canvasRef}
        style={{
          display: 'block',
          width: '100%',
          height: '100%',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          pointerEvents: 'none',
        }}
      />
    </div>
  );
};

export default SecurePDFCanvas;